/**
 * @file Contains email validation rules.
 */
import { msgf } from '@/services/isomorphic/I18NService';
import { isValidEmail } from '@/utils/string-utils';
import type { IValidationResult, Validation } from '../validatable';
import { forms_error_validEmail } from "@/lang/__generated__/ahnu/forms_error_validEmail";

/**
 * Validates that the input is a valid email.
 *
 * @param name - Resource string.
 * @param property - Property key.
 * @param value - The value to validate.
 * @returns Whether the property is valid and an error message.
 */
export const validEmail: Validation<string> = (
  name: string,
  property: string,
  value: string
): IValidationResult => {
  const isValid = isValidEmail(value);

  return {
    isValid,
    errorMessage: isValid
      ? null
      : msgf(forms_error_validEmail, { name: name.toLowerCase() })
  };
};
